import Vue from 'vue'
import router from '../router'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

export const EventBus = new Vue({
  data: {
    IpoCreditIsMounted: false,
    LazyIsMounted: false,
    callback: null,
    Lazy: null,
    utm: {}
  },
  methods: {
    scrollTo (anchor, correction = 0) {
      if (router.history.current.path === '/') {
        this.loadLazy(() => {
          VueScrollTo.scrollTo('#' + anchor, 500, {offset: -77 + correction})
        })
      } else {
        router.push('/', () => {
          Vue.nextTick(() => {
            this.loadLazy(() => {
              VueScrollTo.scrollTo('#' + anchor, 500, {offset: -32 + correction})
            })
          }, 100)
        })
      }
    },

    loadLazy (callback) {
      if (this.LazyIsMounted) {
        // LAZY IS MOUNTED
        callback()
      } else {
        // LAZY IS NOT MOUNTED
        // --- working ---
        this.callback = callback
        this.Lazy = () => import('../components/Lazy')
      }
    },

    // Is In ViewPort
    // ???
    // bottomVisible () {
    //   const scrollY = window.scrollY
    //   const visible = document.documentElement.clientHeight
    //   const pageHeight = document.documentElement.scrollHeight
    //   const bottomOfPage = visible + scrollY >= pageHeight
    //   return bottomOfPage || pageHeight < visible
    // },
    isInViewport (elem) {
      var bounding = elem.getBoundingClientRect()
      return (
        bounding.top < document.documentElement.clientHeight) // &&
      // bounding.bottom >= (window.innerHeight || document.documentElement.clientHeight)
    }

  },
  watch: {
    LazyIsMounted () {
      this.$nextTick(() => {
        if (this.callback) this.callback()
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/helpers/event-bus.js